document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.size-chart-section').forEach(function (section) {
    const buttons = section.querySelectorAll('.size-chart-unit');
    const values = section.querySelectorAll('.size-chart-value');
    const labels = section.querySelectorAll('.unit-label');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        const unit = this.dataset.unit;

        values.forEach(function (value) {
          const inches = parseFloat(value.dataset.inches);

          if (unit === 'cm') {
            value.textContent = (inches * 2.54).toFixed(1);
          } else if (unit === 'metres') {
            value.textContent = (inches * 0.0254).toFixed(3);
          } else {
            value.textContent = inches % 1 === 0 ? inches : inches.toFixed(1);
          }
        });

        let label = 'INCHES';

        if (unit === 'cm') label = 'CM';
        if (unit === 'metres') label = 'METRES';

        labels.forEach(function (item) {
          item.textContent = label;
        });

        buttons.forEach(function (btn) {
          btn.classList.toggle('active', btn === button);
        });
      });
    });
  });
});